import { api } from './api'
import type {
  Invite,
  CreateInviteResponse,
  InvitesListResponse,
} from '../types/invites'

export const invitesService = {
  // Create a new invite
  async createInvite(invitee: string): Promise<Invite> {
    const response = await api.post<CreateInviteResponse>('/api/invites', {
      invitee,
    })
    return response.invite
  },

  // Get invites sent by a member
  async getInvitesSent(member: string): Promise<Invite[]> {
    const response = await api.get<InvitesListResponse>(
      `/api/invites/by-member/${encodeURIComponent(member)}`
    )
    return response.invites
  },

  // Get invites received by an invitee
  async getInvitesReceived(invitee: string): Promise<Invite[]> {
    const response = await api.get<InvitesListResponse>(
      `/api/invites/by-invitee/${encodeURIComponent(invitee)}`
    )
    return response.invites
  },

  // Delete invite(s) to a specific invitee
  async deleteInvite(invitee: string): Promise<void> {
    await api.delete('/api/invites', {
      invitee,
    })
  },
}
